var React = require('react');

function FreeCancellationUpTo24h (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.481 8.329l-3.343 3.343-1.618-1.618M17.709 10a7.708 7.708 0 11-15.417 0 7.708 7.708 0 0115.417 0z","stroke":"#0B77D5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FreeCancellationUpTo24h.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = FreeCancellationUpTo24h;

FreeCancellationUpTo24h.default = FreeCancellationUpTo24h;
